module.exports = __webpack_public_path__ + "static/fonts/Material-Design-Iconic-Font.a4d31128.woff2";